<template>
  <div class="introduction">
    <div class="introduction-title"></div>
    <div class="introduction-content">
      <div class="introduction-content__item">
        <introduction-chapter
          :imgConfigList="
            imgConfig[bankType] && imgConfig[bankType].openBankImgList
          "
          :number="1"
          :rawHtmlText="rawHtmlTextOpen"
          :rawHtmlTip="rawHtmlTipOpen"
          :isFinished="hasOpenThatBank"
          :awardInfo="awardInfoRedEnvelop"
          @openDetailSteps="openDetailSteps('openBank')"
          @download="download"
        />
        <basic-button
          class="introduction-content__item__button"
          :isFinished="hasOpenThatBank"
          :buttonText="hasOpenThatBank ? '已完成' : '去App开通'"
          :btnImg="hasOpenThatBank ? finishedBtnImg : activeBtnImg"
          :fontColor="hasOpenThatBank ? '#222222' : '#4C1111'"
          :bankType="bankType"
          :hasOpenThatBank="hasOpenThatBank"
          :pushSubWalletABStrategy="pushSubWalletABStrategy"
          @download="download"
        />
      </div>
      <div class="introduction-content__icon">
        <div class="introduction-content__icon__src"></div>
      </div>
      <div class="introduction-content__item">
        <introduction-chapter
          :imgConfigList="
            imgConfig[bankType] && imgConfig[bankType].bindWalletImgList
          "
          :number="2"
          :rawHtmlText="rawHtmlTextBind"
          :rawHtmlTip="rawHtmlTipBind"
          :isFinished="currentBankHasBinding"
          :awardInfo="awardInfoCoupon"
          @openDetailSteps="openDetailSteps('bindWallet')"
        />
        <basic-button
          class="introduction-content__item__button"
          :isFinished="currentBankHasBinding"
          :buttonText="currentBankHasBinding ? '已完成' : '去App设置'"
          :btnImg="currentBankHasBinding ? finishedBtnImg : activeBtnImg"
          :fontColor="currentBankHasBinding ? '#222222' : '#4C1111'"
          :bankType="bankType"
          :hasOpenThatBank="hasOpenThatBank"
          :pushSubWalletABStrategy="pushSubWalletABStrategy"
        />
      </div>
    </div>
    <detail-steps
      :visible.sync="showDetailSteps"
      :stepTitle="stepTitle"
      :imgList="imgList"
    />
  </div>
</template>
<script>
import { fetchGuideStepContent } from '@/common/horn';
import { lx } from '@/analytic/index';
import { lxConfig } from '@/analytic/guideConfig';
import { env } from '@/common/env';
import IntroductionChapter from '../../components/IntroductionChapter.vue';
import BasicButton from '../../components/BasicButton.vue';
import DetailSteps from './DetailSteps.vue';
export default {
  components: {
    IntroductionChapter,
    BasicButton,
    DetailSteps
  },
  props: {
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    currentBankHasBinding: {
      type: Boolean,
      default: false
    },
    bankType: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    },
    couponPackage: {
      type: Object,
      default: () => {}
    },
    applyPageType: {
      type: String,
      default: ''
    },
    pageABStrategy: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      stepTitle: '',
      imgList: null,
      showDetailSteps: false,
      awardInfoRedEnvelop: '',
      awardInfoCoupon: '',
      finishedBtnImg:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/finished-btn-img-20220407.png',
      activeBtnImg:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/btn-active-20220407.png',
      imgConfig: {}
    };
  },
  computed: {
    rawHtmlTextBind() {
      return `选择美团，开通<span style="color: #1176D1">${this.bankName}</span>钱包快付`;
    },
    rawHtmlTextOpen() {
      return `下载数字人民币App开通<span style="color: #1176D1">${this.bankName}</span>钱包`;
    },
    userStatus() {
      if (this.currentBankHasBinding) {
        return '已推子';
      }
      if (this.hasOpenThatBank) {
        return '开通未推子';
      }
      if (!this.hasOpenThatBank) {
        return '报名未开通';
      }
    }
  },
  created() {
    this.rawHtmlTipOpen = `立得<span style="color: #F74344">${this
      .couponPackage && this.couponPackage.redEnvelop}元</span>红包`;
    this.rawHtmlTipBind = `立得<span style="color: #F74344">${this
      .couponPackage && this.couponPackage.coupon}元</span>券包`;
    this.awardInfoRedEnvelop = `${this.couponPackage &&
      this.couponPackage
        .redEnvelop}元数字人⺠币红包发放后，可前往数字人⺠币App-服务-红包处查看。`;
    this.awardInfoCoupon = `${this.couponPackage &&
      this.couponPackage
        .coupon}元美团数字人⺠币券包发放后，可前 往美团-数字人⺠币专区-现金券处查看。`;
    this.getGuideStepContent();
    // 攻略下载区
    lx.mv(
      lxConfig.mv_middle_download,
      {
        from: env.from,
        abtest: this.pageABStrategy,
        page_type: this.applyPageType,
        user_status: this.userStatus || -999
      },
      {
        cid: lxConfig.pv
      }
    );
  },
  methods: {
    openDetailSteps(step) {
      this.showDetailSteps = true;
      lx.mc(
        lxConfig.mc_detail_step,
        {
          from: env.from
        },
        {
          cid: lxConfig.pv
        }
      );
      if (step === 'openBank') {
        this.stepTitle = `开通${this.bankName}钱包`;
        this.imgList =
          this.imgConfig && this.imgConfig[this.bankType].openBankImgList;
      }
      if (step === 'bindWallet') {
        this.stepTitle = '选择美团开通钱包快付';
        this.imgList =
          this.imgConfig && this.imgConfig[this.bankType].bindWalletImgList;
      }
    },
    getGuideStepContent() {
      fetchGuideStepContent()
        .then((res) => {
          if (!res) {
            throw new Error('res为空');
          }
          this.imgConfig = res.imgConfig || {};
        })
        .catch((error) => {
          console.log('horn error:', error);
        });
    },
    download() {
      lx.mc(
        lxConfig.mc_middle_download,
        {
          from: env.from,
          abtest: this.pageABStrategy,
          page_type: this.applyPageType,
          user_status: this.userStatus || -999
        },
        {
          cid: lxConfig.pv
        }
      );
    }
  },
  watch: {
    couponPackage: {
      handler(newVal) {
        this.awardInfoRedEnvelop = `${newVal &&
          newVal.redEnvelop}元数字人⺠币红包发放后，可前往数字人⺠币App-服务-红包处查看。`;
        this.awardInfoCoupon = `${newVal &&
          newVal.coupon}元美团数字人⺠币券包发放后，可前 往美团-数字人⺠币专区-现金券处查看。`;
        this.rawHtmlTipOpen = `立得<span style="color: #F74344">${newVal &&
          newVal.redEnvelop}元</span>红包`;
        this.rawHtmlTipBind = `立得<span style="color: #F74344">${newVal &&
          newVal.coupon}元</span>券包`;
      },
      deep: true
    }
  }
};
</script>
<style scoped lang="less">
@import '../../../../styles/fn.less';
.introduction {
  position: relative;
  background-image: linear-gradient(180deg, #edf7fe 0%, #ffffff 100%);
  border-radius: 0.3rem;
  margin: 0 auto;
  &-title {
    position: absolute;
    width: 3.08rem;
    height: 0.61rem;
    left: 50%;
    transform: translateX(-50%);
    .bg-image-auto(
      'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/guide-header-title-20220407.png'
    );
  }
  &-content {
    display: flex;
    justify-content: center;
    padding: 0.94rem 0.2rem 0.43rem 0.2rem;
    &__icon {
      height: 0.95rem;
      padding-top: 0.21rem;
      margin: 0 0.1rem;
      &__src {
        width: 0.43rem;
        height: 0.43rem;
        .bg-image-auto(
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/guide-arrow-20220407.png'
        );
      }
    }
    &__item {
      margin: 0 auto;
      &__button {
        margin-top: 0.31rem;
      }
    }
  }
}
</style>
